import _definePage_default_0 from '/builds/ebanking/banking-admin-dashboard/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/builds/ebanking/banking-admin-dashboard/src/pages/change-pwd.vue?definePage&vue'
import _definePage_default_3 from '/builds/ebanking/banking-admin-dashboard/src/pages/login.vue?definePage&vue'
import _definePage_default_4 from '/builds/ebanking/banking-admin-dashboard/src/pages/operational/infractions/[tab].vue?definePage&vue'
import _definePage_default_5 from '/builds/ebanking/banking-admin-dashboard/src/pages/operational/infractions-automation/index.vue?definePage&vue'
import _definePage_default_6 from '/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/index.vue?definePage&vue'
import _definePage_default_7 from '/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/master-fee.vue?definePage&vue'
import _definePage_default_8 from '/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/platform-fee.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/access-control',
    /* internal name: 'access-control' */
    /* no component */
    children: [
      {
        path: '',
        name: 'access-control',
        component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/access-control/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/blank',
    name: 'blank',
    component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/blank.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/change-pwd',
    name: 'change-pwd',
    component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/change-pwd.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/financial',
    /* internal name: 'financial' */
    /* no component */
    children: [
      {
        path: 'billing-list',
        /* internal name: 'financial-billing-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'financial-billing-list',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/financial/billing-list/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'financial-dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: 'financial-dashboard',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/financial/dashboard/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'str-calendar',
        /* internal name: 'financial-str-calendar' */
        /* no component */
        children: [
          {
            path: '',
            name: 'financial-str-calendar',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/financial/str-calendar/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'transactions',
        /* internal name: 'financial-transactions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'financial-transactions',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/financial/transactions/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/operational',
    /* internal name: 'operational' */
    /* no component */
    children: [
      {
        path: 'billing-list',
        /* internal name: 'operational-billing-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-billing-list',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/billing-list/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dashboard',
        /* internal name: 'operational-dashboard' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-dashboard',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/dashboard/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'error-cases',
        /* internal name: 'operational-error-cases' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-error-cases',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/error-cases/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'fee',
        /* internal name: 'operational-fee' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-fee',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/fee/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'funds-freeze',
        /* internal name: 'operational-funds-freeze' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-funds-freeze',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/funds-freeze/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'infractions',
        /* internal name: 'operational-infractions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-infractions',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/infractions/index.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'operational-infractions-tab',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/infractions/[tab].vue'),
            /* no children */
          },
  _definePage_default_4
  )
        ],
      },
      {
        path: 'infractions-automation',
        /* internal name: 'operational-infractions-automation' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'operational-infractions-automation',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/infractions-automation/index.vue'),
            /* no children */
          },
  _definePage_default_5
  )
        ],
      },
      {
        path: 'kyb',
        /* internal name: 'operational-kyb' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-kyb',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/kyb/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'kyc',
        /* internal name: 'operational-kyc' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-kyc',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/kyc/index.vue'),
            /* no children */
          },
          {
            path: ':user_id',
            name: 'operational-kyc-user_id',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/kyc/[user_id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'limits-list',
        /* internal name: 'operational-limits-list' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-limits-list',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/limits-list/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'logs',
        /* internal name: 'operational-logs' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-logs',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/logs/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'med',
        /* internal name: 'operational-med' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-med',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/med/index.vue'),
            /* no children */
          },
          {
            path: ':case_id',
            name: 'operational-med-case_id',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/med/[case_id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'merchantApi',
        /* internal name: 'operational-merchant-api' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-merchant-api',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/merchantApi/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'newFee',
        /* internal name: 'operational-new-fee' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '/operational/newFee',
            name: 'operational-new-fee',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/index.vue'),
            /* no children */
          },
  _definePage_default_6
  ),
  _mergeRouteRecord(
          {
            path: '/operational/newFee/master-fee',
            name: 'operational-new-fee-master-fee',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/master-fee.vue'),
            /* no children */
          },
  _definePage_default_7
  ),
  _mergeRouteRecord(
          {
            path: '/operational/newFee/platform-fee',
            name: 'operational-new-fee-platform-fee',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/platform-fee.vue'),
            /* no children */
          },
  _definePage_default_8
  ),
          {
            path: 'components',
            /* internal name: 'operational-new-fee-components' */
            /* no component */
            children: [
              {
                path: 'EffectiveTimeSetting',
                name: 'operational-new-fee-components-effective-time-setting',
                component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/components/EffectiveTimeSetting.vue'),
                /* no children */
              },
              {
                path: 'FeeConfigurationContent',
                name: 'operational-new-fee-components-fee-configuration-content',
                component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/components/FeeConfigurationContent.vue'),
                /* no children */
              },
              {
                path: 'PresetRatesList',
                name: 'operational-new-fee-components-preset-rates-list',
                component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/components/PresetRatesList.vue'),
                /* no children */
              },
              {
                path: 'VersionHistorySelect',
                name: 'operational-new-fee-components-version-history-select',
                component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/newFee/components/VersionHistorySelect.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'pix-key-controls',
        /* internal name: 'operational-pix-key-controls' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-pix-key-controls',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/pix-key-controls/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'pix-keys',
        /* internal name: 'operational-pix-keys' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-pix-keys',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/pix-keys/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'return-required',
        /* internal name: 'operational-return-required' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-return-required',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/return-required/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'transactions',
        /* internal name: 'operational-transactions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-transactions',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/transactions/index.vue'),
            /* no children */
          },
          {
            path: ':trade_no',
            name: 'operational-transactions-trade_no',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/transactions/[trade_no].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'operational-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'operational-users',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/users/index.vue'),
            /* no children */
          },
          {
            path: ':user_id',
            name: 'operational-users-user_id',
            component: () => import('/builds/ebanking/banking-admin-dashboard/src/pages/operational/users/[user_id].vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
